import { logInfo } from "../utils/log";

export const DEFAULT_WAIT_FOR_ELEMENT_TIMEOUT = 600;

/**
 *
 * @param selector CSS selector to wait for
 * @param timeout max period (in ms) to wait for the CSS selector
 * @returns HTML element waited for or undefined
 */
export const waitForElementByCssSelector = async (
  selector: string,
  timeout = DEFAULT_WAIT_FOR_ELEMENT_TIMEOUT,
  rootDocument: Document | null = null
): Promise<Element | null> => {
  const doc = rootDocument || document;
  logInfo("Waiting for element inside document ", { selector, doc });

  return new Promise((resolve) => {
    const startObserving = () => {
      const element = doc.querySelector(selector);
      if (element) {
        resolve(element);
        return;
      }

      const observer = new MutationObserver(() => {
        const element = doc.querySelector(selector);
        if (element) {
          observer.disconnect();
          resolve(element);
        }
      });

      observer.observe(doc.body, {
        childList: true,
        subtree: true,
      });

      // Start timeout only after DOM is loaded
      setTimeout(() => {
        observer.disconnect();
        resolve(null);
      }, timeout);
    };

    startObserving();
  });
};
